import type moment from 'moment'

export enum ActionBarActionType {
    ADD = 'add',
    UPLOAD = 'upload',
    DELETE = 'delete',
    DATE_INTERVAL = 'dateInterval',
}

export enum ActionBarRequestHeaderType {
    DEFAULT = 'default',
    WITH_AUTH = 'with_auth',
}

interface ActionBarActionBase {
    order: number
    options?: {
        [key: string]: string
    }
}

export interface ActionBarButtonAction extends ActionBarActionBase {
    type: ActionBarActionType.ADD | ActionBarActionType.UPLOAD | ActionBarActionType.DELETE
    cb: () => void
}

export interface ActionBarDateIntervalAction extends ActionBarActionBase {
    type: ActionBarActionType.DATE_INTERVAL
    dateBegin: moment.MomentInput
    dateEnd: moment.MomentInput
    cb: (data: { type: 'begin' | 'end'; value: string }) => void
}

export type ActionBarAction = ActionBarButtonAction | ActionBarDateIntervalAction
